import ContentTemplatesPageBlock from './ContentTemplatesPage';

export default ContentTemplatesPageBlock;
